import React from "react";
import styled from "styled-components";
import { useAppSelector } from "../../store/hooks";
import { useGetRespectRivalriesQuery } from "../../services/rtkApi/respectApi";

const Line = styled.p`
  font-family: "Courier New", Courier, monospace;
  font-size: 0.8rem;
  color: #1f3140;
  margin: -18px 30px 12px 30px;
  align-self: flex-start;
  max-width: 900px;
`;

const Name = styled.span`
  font-weight: bold;
  color: #111;
`;

/**
 * One line under the aotd stats: who has taken the most respect off you, and
 * who has handed you the most. The pair ledger is per-player, so this is the
 * only place the numbers mean anything without a whole rivalry screen around
 * them.
 *
 * Renders nothing until the session is restored, and nothing at all when the
 * viewer has never traded respect with anybody — which is everyone until the
 * cards start moving money, so the guard is the normal case, not an edge one.
 */
const RivalryLine: React.FC = () => {
  const bootstrapStatus = useAppSelector((state) => state.auth.bootstrapStatus);
  const token = useAppSelector((state) => state.auth.token);
  const ready = bootstrapStatus === "ready" && !!token;

  const { data } = useGetRespectRivalriesQuery(undefined, { skip: !ready });

  const nemesis = data?.data?.nemesis ?? null;
  const benefactor = data?.data?.benefactor ?? null;
  if (!ready || (!nemesis && !benefactor)) return null;

  return (
    <Line>
      {nemesis && (
        <>
          nemesis: <Name>@{nemesis.username ?? "someone"}</Name>, took{" "}
          {nemesis.tookFromYou} off you.
        </>
      )}
      {nemesis && benefactor && " "}
      {benefactor && (
        <>
          benefactor: <Name>@{benefactor.username ?? "someone"}</Name>, gave you{" "}
          {benefactor.gaveToYou}.
        </>
      )}
    </Line>
  );
};

export default RivalryLine;
